/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overlap_DetectionInputs */

const en_overlap_detection = /** @type {(inputs: Overlap_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overlap Detection`)
};

const fr_overlap_detection = /** @type {(inputs: Overlap_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Détection des chevauchements`)
};

const de_overlap_detection = /** @type {(inputs: Overlap_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überlappungserkennung`)
};

const it_overlap_detection = /** @type {(inputs: Overlap_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilevamento sovrapposizione`)
};

const ru_overlap_detection = /** @type {(inputs: Overlap_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обнаружение перекрытия`)
};

const es_overlap_detection = /** @type {(inputs: Overlap_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detección de superposición`)
};

const zh_cn2_overlap_detection = /** @type {(inputs: Overlap_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重叠检测`)
};

const ja_overlap_detection = /** @type {(inputs: Overlap_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複検出`)
};

const hi_overlap_detection = /** @type {(inputs: Overlap_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरलैप डिटेक्शन`)
};

const pt_pt2_overlap_detection = /** @type {(inputs: Overlap_DetectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detecção de sobreposição`)
};

/**
* | output |
* | --- |
* | "Overlap Detection" |
*
* @param {Overlap_DetectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const overlap_detection = /** @type {((inputs?: Overlap_DetectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overlap_DetectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_overlap_detection(inputs)
	if (locale === "de") return de_overlap_detection(inputs)
	if (locale === "it") return it_overlap_detection(inputs)
	if (locale === "ru") return ru_overlap_detection(inputs)
	if (locale === "es") return es_overlap_detection(inputs)
	if (locale === "zh-CN") return zh_cn2_overlap_detection(inputs)
	if (locale === "ja") return ja_overlap_detection(inputs)
	if (locale === "hi") return hi_overlap_detection(inputs)
	if (locale === "pt-PT") return pt_pt2_overlap_detection(inputs)
	return en_overlap_detection(inputs)
});